import * as api from "../api";
import { toast } from "react-toastify";
import {
  FETCH_HEALTHCARE_PROFILE,
  UPDATE_HEALTHCARE_PROFILE,
  START_LOADING,
  END_LOADING,
  FETCH_HEALTHCARE_PROFILE_ERROR,
  FETCH_HEALTHCARE_VENDORS,
  DELETE_HEALTHCARE_VENDOR,
} from "../constants/actionTypes";

export const fetchHealthcareProfile = (vendorId) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });

    const { data } = await api.apiFetchHealthcareProfile(vendorId);

    dispatch({ type: FETCH_HEALTHCARE_PROFILE, payload: data });

    dispatch({ type: END_LOADING });
  } catch (error) {
    dispatch({ type: FETCH_HEALTHCARE_PROFILE_ERROR, payload: error.message });
    dispatch({ type: END_LOADING });
  }
};

export const fetchHealthcareVendors =
  (adminId, isSuperAdmin) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });

      const { data } = await api.apiFetchHealthcareVendors(
        adminId,
        isSuperAdmin
      );

      dispatch({
        type: FETCH_HEALTHCARE_VENDORS,
        payload: data.healthcareVendors || [],
      });

      dispatch({ type: END_LOADING });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch healthcare vendors";
      dispatch({
        type: FETCH_HEALTHCARE_PROFILE_ERROR,
        payload: message,
      });
      dispatch({ type: END_LOADING });
    }
  };

export const updateHealthcareProfile =
  (vendorId, formData) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });

      const { data } = await api.apiUpdateHealthcareProfile(vendorId, formData);

      dispatch({ type: UPDATE_HEALTHCARE_PROFILE, payload: data });

      dispatch({ type: END_LOADING });
      return data;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to update healthcare vendor";
      dispatch({
        type: FETCH_HEALTHCARE_PROFILE_ERROR,
        payload: message,
      });
      dispatch({ type: END_LOADING });
      toast.error(message);
      throw error;
    }
  };

export const deleteHealthcareVendor = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.apiDeleteHealthcareVendor(id);

    dispatch({ type: DELETE_HEALTHCARE_VENDOR, payload: id });
    toast.success(data.message || "Healthcare vendor deleted successfully");
    return data;
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Failed to delete healthcare vendor";
    toast.error(message);
    throw error;
  } finally {
    dispatch({ type: END_LOADING });
  }
};
